import { render, staticRenderFns } from "./Waivers.vue?vue&type=template&id=649b98fe&scoped=true&"
import script from "./Waivers.vue?vue&type=script&lang=js&"
export * from "./Waivers.vue?vue&type=script&lang=js&"
import style0 from "./Waivers.vue?vue&type=style&index=0&id=649b98fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649b98fe",
  null
  
)

export default component.exports